/**
 * In-memory session token for API auth.
 * Security Checklist: do not persist to localStorage/sessionStorage.
 * Set after verify-otp; cleared on logout. apiClient reads this for Bearer / X-Session-Token.
 */

let sessionToken: string | null = null;

export function getSessionToken(): string | null {
  return sessionToken;
}

export function setSessionToken(token: string | null): void {
  sessionToken = token;
}
